/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'angular2-qrcode';
class QRCodeModuleInjector extends import0.ɵNgModuleInjector<import1.QRCodeModule> {
  _QRCodeModule_0:import1.QRCodeModule;
  constructor(parent:import0.Injector) {
    super(parent,([] as any[]),([] as any[]));
  }
  createInternal():import1.QRCodeModule {
    this._QRCodeModule_0 = new import1.QRCodeModule();
    return this._QRCodeModule_0;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import1.QRCodeModule)) { return this._QRCodeModule_0; }
    return notFoundResult;
  }
  destroyInternal():void {
  }
}
export const QRCodeModuleNgFactory:import0.NgModuleFactory<import1.QRCodeModule> = new import0.NgModuleFactory<any>(QRCodeModuleInjector,import1.QRCodeModule);
const styles_QRCodeComponent:any[] = ([] as any[]);
export const RenderType_QRCodeComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_QRCodeComponent,
  data: {}
}
);
export function View_QRCodeComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_QRCodeComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'qr-code',([] as any[]),(null as any),(null as any),(null as any),View_QRCodeComponent_0,RenderType_QRCodeComponent)),
    import0.ɵdid(573440,(null as any),0,import1.QRCodeComponent,[import0.ElementRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const QRCodeComponentNgFactory:import0.ComponentFactory<import1.QRCodeComponent> = import0.ɵccf('qr-code',import1.QRCodeComponent,View_QRCodeComponent_Host_0,{
  background: 'background',
  backgroundAlpha: 'backgroundAlpha',
  foreground: 'foreground',
  foregroundAlpha: 'foregroundAlpha',
  level: 'level',
  mime: 'mime',
  padding: 'padding',
  size: 'size',
  value: 'value',
  canvas: 'canvas'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9hbmd1bGFyMi1xcmNvZGUvbGliL2FuZ3VsYXIyLXFyY29kZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvYW5ndWxhcjItcXJjb2RlL2xpYi9hbmd1bGFyMi1xcmNvZGUuZC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9hbmd1bGFyMi1xcmNvZGUvbGliL2FuZ3VsYXIyLXFyY29kZS5kLnRzLlFSQ29kZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxxci1jb2RlPjwvcXItY29kZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtnQkFBQTs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/angular2-qrcode/lib/angular2-qrcode.ngfactory.ts